import { render, staticRenderFns } from "./DriverFields.vue?vue&type=template&id=264eea4b"
import script from "./DriverFields.vue?vue&type=script&lang=js"
export * from "./DriverFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports